import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.14,
  animate = false,
}) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(animate ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.4 } })}
  >
    {lines.map((line, i) => (
      <span key={i} className={`block overflow-hidden ${lineClassName}`}>
        <motion.span
          className="block will-change-transform"
          variants={{ hidden: { y: "115%" }, show: { y: "0%" } }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
